(function($){
	$(document).ready(function(){
		$( '.site-header' ).after( '<div class="nav-spacer d-none"></div>' );

		var stuckNav = false;
		var navbarHeight;
		var sizeNavSpacer = function(){
			navbarHeight =  $( '.site-header' ).outerHeight();
			$( '.nav-spacer' ).css( { 'height' : navbarHeight } );
			if ( !stuckNav ) {
				stuckNav = true;
				$( '.site-header' ).addClass( 'sticky' );
				$( '.nav-spacer' ).removeClass( 'd-none' );
			}
		}
		sizeNavSpacer();
		var initLockHeader = function( el ){
			var itemHeight =  $(el).outerHeight();
			var offsetTop =  (el.getBoundingClientRect().top + window.scrollY) - navbarHeight;
			if ( !$( el ).data( 'lock-init' ) ) {
				$( el ).data( 'lock-init', true );
				$( el ).wrap( '<div class="lock-header-wrap"></div>' );
			}

			var parentWrapper = $(el).parent();
			var region = parentWrapper.closest( '.lock-region' );
			

			parentWrapper.data( 'offset', offsetTop );
			parentWrapper.data( 'region-height', region.outerHeight() );
			
			parentWrapper.css( {'height': itemHeight} );
		};
		var initLockHeaders = function(){
			$( '.lock-header' ).each( function(){
				initLockHeader( this) 
			});
		}

		var checkHeader = function( el, top ){

			if ( !$( el ).data( 'lock-init' ) ){
				initLockHeader(el);
			}
			var parentWrapper = $(el).parent();

			if ( $('body').hasClass( 'fl-builder-edit' ) ) {

				parentWrapper.removeClass( 'locked-header' );
				$(el).css({ 'top': 0 });
				return;
			}

			var diff = $( 'body' ).hasClass( 'admin-bar' ) ? 42: 20;
			// console.log( top, parentWrapper.data('offset'), parentWrapper.data( 'region-height' ) );
			var x = parentWrapper.data('offset');
			var y = parentWrapper.data( 'region-height' );
			var start = x - diff;
			var end = x + y;

			if ( top > start && top < end  ) {
				parentWrapper.addClass( 'locked-header' );
				$(el).css({ 'top': navbarHeight });
			} else {
				parentWrapper.removeClass( 'locked-header' );
				$(el).css({ 'top': 0 });
			}
		};

		initLockHeaders();
		$( window ).on( 'resize orientationchange', sizeNavSpacer );
		$( window ).on( 'resize orientationchange', initLockHeaders );

		$( window ).on( 'scroll', function(){
			var st = $(this).scrollTop();
			if ( st > 10 ) {
				$( '.site-header' ).addClass( 'stuck' );
			} else {
				$( '.site-header' ).removeClass( 'stuck' );
			}
			$( '.lock-header' ).each( function(){
				checkHeader( this, st );
			} );
		} );

	})
})(jQuery)